import React from 'react'
import Modal from 'react-bootstrap/Modal';

export default function AppModalHeader({ title, hideDefaultClose = false }) {
  return (
    <Modal.Header closeButton={!hideDefaultClose}>
      <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
    </Modal.Header>
  )
}
